import axios from "axios";

// VAPID_PUBLIC_KEY 가져오는 함수
export async function getVapidPublicKey() {
  try {
    const response = await axios.get(process.env.VUE_APP_API_BASE_URL + "/vapid-public-key/");

    console.log("🔍 VAPID_PUBLIC_KEY 확인:", response.data.vapidPublicKey);

    return response.data.vapidPublicKey;

  } catch (error) {
    console.error("❌ VAPID_PUBLIC_KEY 가져오기 실패:", error);
    return null;
  }
}



export default getVapidPublicKey